import { HttpClient } from "@angular/common/http";
import { inject, Injectable } from "@angular/core";
import { InternalReferentialsBaseService } from "src/app/core/base/internal-referentials-base.service";
import { environment } from "src/environments/environment";
import { Country } from "./country.model";

export const COUNTRY_BASE_URL = `${environment.baseUrl}/engine/countries`;

@Injectable({
  providedIn: "root",
})
export class CountryService extends InternalReferentialsBaseService<
  Country,
  number
> {
  constructor() {
    const httpClient = inject(HttpClient);

    super(httpClient, COUNTRY_BASE_URL);
  }
}
